import styles from './Table.module.css'

function Row({ children }: { children: React.ReactNode }) {
  return <tr className={styles.row}>{children}</tr>
}

export default Row
